<template>

  <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                   Dodjeljeni eduID
                    <v-icon slot="divider" @click="getData()" style="padding-bottom: 2px;">mdi-refresh</v-icon>
                </span>

        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>


      </v-col>

    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="6">
        <v-text-field
            outlined

            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="$checkPermission('educational_fields index')">
        <v-autocomplete
            outlined
            :items="cantons.items"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi županiju.."
            v-model="select_canton"
            dense
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>

      <!--    :options.sync="options"-->
      <!--    :server-items-length="serverItemsLength"-->
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:[`item.name`]="{ item }">
            <td style="min-width: 250px">
              <span style="color: #084776 !important;">{{ item.name }}</span>
            </td>
          </template>
<!--          <template v-slot:[`item.pupils_total`]="{ item }">-->
<!--              <span class="font-weight-bold">{{ item.pupils_total }}</span>-->
<!--          </template>-->
          <template v-slot:[`item.pupils_eduid`]="{ item }">
            <span>{{ item.pupils_eduid }}</span>
          </template>
<!--          <template v-slot:[`item.pupils_without_eduid`]="{ item }">-->
<!--            <span style="color: red" >{{ item.pupils_without_eduid }}</span>-->
<!--          </template>-->
          <template v-slot:[`item.pupils_percentage`]="{ item }">
            <span v-if="item.pupils_percentage !== undefined" style="color: green" >{{ item.pupils_percentage + ' %'}}</span>
            <span v-else >-</span>
          </template>
<!--          <template v-slot:[`item.employees_total`]="{ item }">-->
<!--            <span class="font-weight-bold">{{ item.employees_total }}</span>-->
<!--          </template>-->
          <template v-slot:[`item.eymploees_eduid`]="{ item }">
            <span  >{{ item.eymploees_eduid }}</span>
          </template>
<!--          <template v-slot:[`item.eymploees_without_eduid`]="{ item }">-->
<!--            <span style="color: red" >{{ item.eymploees_without_eduid }}</span>-->
<!--          </template>-->
          <template v-slot:[`item.employees_percentage`]="{ item }">
            <span style="color: green" >{{ item.employees_percentage + ' %'}}</span>
          </template>
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>

          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!--    <v-row :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">-->
    <!--      <template v-for="(item, val, i) in popis.izvjestaj">-->
    <!--        <v-col cols="12" md="4" :key="i">-->
    <!--          <v-card outlined class="px-3" height="100%">-->
    <!--            <v-row>-->
    <!--              <v-col cols="12">-->
    <!--                <div style="background-color: #004379; border-radius: 4px" class="text-center py-7">-->
    <!--                  <v-icon v-if="val == 'ukupan_broj_ucenika' || val == 'ukupan_broj_djelatnika'" size="50" color="white">mdi-account-group</v-icon>-->
    <!--                  <v-img v-else-if="val == 'ucenici_s_eduId' || val =='djelatnici_s_eduId'" class="text-center" style="margin-right: auto; margin-left: auto" width="80px" src="@/assets/img/eduID_white.svg"></v-img>-->
    <!--                  <v-icon v-else-if="val == 'ucenici_bez_eduId'" size="50" color="white">mdi-face</v-icon>-->
    <!--                  <v-icon v-else-if="val == 'djelatnici_bez_eduId'" size="50" color="white">mdi-clipboard-account</v-icon>-->
    <!--                </div>-->
    <!--              </v-col>-->

    <!--              <v-col cols="12">-->
    <!--                <div v-if="val == 'ukupan_broj_ucenika'" class="text-h7  text-center"> <b>Ukupan broj učenika:</b> {{item}}</div>-->
    <!--                <div v-else-if="val == 'ucenici_s_eduId'" class="text-h7  text-center"> <b>Učenici s eduID:</b> {{item}}</div>-->
    <!--                <div v-else-if="val == 'ucenici_bez_eduId'" class="text-h7  text-center"> <b>Učenici bez eduID:</b> {{item}}</div>-->
    <!--                <div v-else-if="val == 'ukupan_broj_djelatnika'" class="text-h7  text-center"> <b>Ukupan broj djelatnika:</b> {{item}}</div>-->
    <!--                <div v-else-if="val == 'djelatnici_s_eduId'" class="text-h7  text-center"> <b>Djelatnici s eduID:</b> {{item}}</div>-->
    <!--                <div v-else-if="val == 'djelatnici_bez_eduId'" class="text-h7  text-center"> <b>Djelatnici bez eduID:</b> {{item}}</div>-->
    <!--              </v-col>-->
    <!--            </v-row>-->
    <!--          </v-card>-->
    <!--        </v-col>-->
    <!--      </template>-->
    <!--    </v-row>-->
  </v-container>
</template>

<script>
import {serverBus} from "../../main";

export default {
  components: {},

  created: function () {
    if(localStorage.getItem('eduid-search')){
      this.search = localStorage.getItem('eduid-search')
    }
    if(localStorage.getItem('eduid-canton')){
      this.select_canton = parseInt(localStorage.getItem('eduid-canton'))
    }
    // this.getData()
    this.getCantons()
    this.getDataTable()
    serverBus.$on('reload-all-data', () => {
      // this.getData()
      this.getDataTable()
    })
  },


  mounted: function () {

  },
watch:{
    select_canton:{
      handler(){
        localStorage.setItem('eduid-canton',this.select_canton)
      },  
      deep: true
    },
    search:{
      handler(){
        localStorage.setItem('eduid-search', this.search)
      },
      deep: true
    }
  },
  methods: {
    getDataTable() {
      this.loading = true;
      serverBus.$emit('perform-layout-loading', true);
      this.$axios.get(`/ostalo/report_eduid_table`, {
        params: {
          canton_id: this.select_canton
        }
      })
          .then((response) => {
            this.dataTable = response.data;
          }).catch(() => {
        serverBus.$emit('perform-layout-loading', false);

        serverBus.$emit('show-snackbar', false, 'Problem sa popisom eduID izvještajem.')

      }).finally(() => {
        this.loading = false;
        serverBus.$emit('perform-layout-loading', false);
      });
    },
    getData() {
      serverBus.$emit('perform-layout-loading', true);

      this.$axios.get('ostalo/report_eduid_number')
          .then((response) => {
            this.popis = response.data;

          }).catch(() => {
        serverBus.$emit('perform-layout-loading', false);

        serverBus.$emit('show-snackbar', false, 'Problem sa popisom eduID izvještajem.')

      }).finally(() => {

        serverBus.$emit('perform-layout-loading', false);
      });
    },
    performSearch: function () {
      let self = this;

      clearTimeout(this.searchTimeout);

      this.searchTimeout = null;
      this.searchTimeout = setTimeout(function () {
        serverBus.$emit('perform-search', self.search);

        self.searchTimeout = null;
      }, 300);
    },
    getCantons() {
      this.$axios.post('zupanija').then((response) => {
        this.cantons = response.data;
        this.cantons.items.push({'id': null, 'title': 'Prikaži sve škole'})
      })
    },
  },

  data: function () {
    return {
      popis: [],
      dataTable: [],
      search: '',
      searchTimeout: null,
      cantons: [],
      loading: false,
      select_canton: null,
      headers: [
        {
          text: 'Škola',
          value: 'name',
        },
    //    {text: 'Učenici', value: 'pupils_total'},
        {text: 'Učenici sa eduID', value: 'pupils_eduid'},
    //    {text: 'Bez eduID', value: 'pupils_without_eduid'},
        {text: 'Postotak dodjeljenih eduID', value: 'pupils_percentage'},
    //    {text: 'Djelatnici', value: 'employees_total'},
        {text: 'Nastavnici sa eduID', value: 'eymploees_eduid'},
    //    {text: 'Bez eduID', value: 'eymploees_without_eduid'},
        {text: 'Postotak dodjeljenih eduID', value: 'employees_percentage'},
      ],
      breadcrumbs: [{text: "Administracija"}, {text: "Izvještaji"}, {text: "Dodjeljeni eduID"}],
    }
  },
  
  beforeDestroy(){
    localStorage.removeItem('eduid-canton')
    localStorage.removeItem('eduid-search')
  }
}

</script>

<style scoped>

</style>